import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { anomaliesApi } from '../../api/anomalies.api';
import type { Anomaly } from '../../types/Anomaly';

const anomaliesAdapter = createEntityAdapter<Anomaly, string>({
  selectId: (anomaly: Anomaly) => anomaly.id,
});

export const anomaliesReducer = createSlice({
  name: 'anomaliesReducer',
  initialState: anomaliesAdapter.getInitialState({
    count: 0,
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(anomaliesApi.endpoints.getAnomalies.matchFulfilled, (state, action) => {
      anomaliesAdapter.removeAll(state);
      anomaliesAdapter.addMany(state, action.payload.results);
      state.count = action.payload.count;
    });
  },
  selectors: {
    selectCount: state => state.count,
  },
});

export const anomaliesSelector = anomaliesAdapter.getSelectors<RootState>(state => {
  return state.anomaliesReducer;
});

export const anomaliesCountSelector = anomaliesReducer.selectors.selectCount;
